import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class CommunitiesApi {
  static getCommunities({ search = '' }) {
    const request = new Request(`${apiUrl}/content/community/all?search=${search}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

  static getCommunityById(id) {
    const request = new Request(`${apiUrl}/content/community/${id}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

  static createCommunity(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const request = new Request(`${apiUrl}/content/community`, {
      method: 'POST',
      headers: getHeaders({}, true),
      body: formData,
    });

    return fetchRequest(request);
  }

  static deleteCommunity(id) {
    const request = new Request(`${apiUrl}/content/community/${id}`, {
      method: 'DELETE',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

  static updateCommunity(payload) {
    const formData = new FormData();
    Object.entries(payload.data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const request = new Request(`${apiUrl}/content/community/${payload.communityId}`, {
      method: 'PUT',
      headers: getHeaders({}, true),
      body: formData,
    });

    return fetchRequest(request);
  }
}

export default CommunitiesApi;
